class CollectionSizeSwatches extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Vi bruger ikke længere denne JavaScript-komponent
    // da vi har skiftet til en simplere HTML/CSS-baseret løsning
  }
}

customElements.define('collection-size-swatches', CollectionSizeSwatches);

// Tilføj event listeners til farve-swatches
document.addEventListener('DOMContentLoaded', () => {
  // Initialiser med det samme - ingen forsinkelse nødvendig
  initColorSwatches();
  
  // Lyt efter når produktanbefalinger er blevet indlæst
  document.addEventListener('product-recommendations:loaded', () => {
    // Geninitialisér farve-swatches efter produktanbefalinger indlæses
    setTimeout(initColorSwatches, 100);
  });
});

// Observer til at detektere dynamisk indlæste produktanbefalinger
const recommendationsObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && 
           (node.classList?.contains('product-list__inner') || 
            node.querySelector?.('.product-list__inner'))) {
          // Produktanbefalinger er indlæst
          setTimeout(initColorSwatches, 100);
        }
      }
    }
  }
});

// Start observeren på dokumentet
document.addEventListener('DOMContentLoaded', () => {
  const recommendationsSection = document.querySelector('product-recommendations');
  if (recommendationsSection) {
    recommendationsObserver.observe(recommendationsSection, { childList: true, subtree: true });
  }
});

function initColorSwatches() {
  const productItems = document.querySelectorAll('product-item');
  
  productItems.forEach(item => {
    const colorSwatches = item.querySelectorAll('.color-swatch__radio');
    const sizeSwatchContainer = item.querySelector('.product-grid-options-size');
    
    if (!colorSwatches.length || !sizeSwatchContainer) return;
    
    const variantsDataElement = item.querySelector('.product-variants-data');
    if (!variantsDataElement) return;
    
    try {
      const variants = JSON.parse(variantsDataElement.textContent);
      
      // Fjern eventuelle eksisterende event listeners
      colorSwatches.forEach(colorInput => {
        colorInput.removeEventListener('change', handleColorChange);
        colorInput.addEventListener('change', handleColorChange);
      });
      
      // Initial opdatering baseret på den valgte farve
      const checkedColorInput = item.querySelector('.color-swatch__radio:checked');
      if (checkedColorInput) {
        updateSizesForColor(checkedColorInput.value, variants, sizeSwatchContainer);
      } else if (colorSwatches.length > 0) {
        // Hvis ingen farve er valgt, brug den første
        updateSizesForColor(colorSwatches[0].value, variants, sizeSwatchContainer);
      }
      
    } catch (error) {
      // Stille fejl - ingen debugging i produktionskode
    }
  });
}

function handleColorChange(event) {
  const productItem = event.target.closest('product-item');
  const sizeContainer = productItem.querySelector('.product-grid-options-size');
  const variantsData = productItem.querySelector('.product-variants-data');
  
  if (!sizeContainer || !variantsData) return;
  
  try {
    const variants = JSON.parse(variantsData.textContent);
    updateSizesForColor(event.target.value, variants, sizeContainer);
  } catch (error) {
    // Stille fejl - ingen debugging i produktionskode
  }
}

function updateSizesForColor(selectedColor, variants, sizeContainer) {
  // Hurtig cache af positioner for bedre ydeevne
  let colorOptionPosition = -1;
  let sizeOptionPosition = -1;
  
  // Find først en variant der har den valgte farve for at få farvepositions-indekset
  for (let i = 0; i < variants.length; i++) {
    const variant = variants[i];
    for (let j = 0; j < variant.options.length; j++) {
      if (variant.options[j] === selectedColor) {
        colorOptionPosition = j;
        break;
      }
    }
    if (colorOptionPosition >= 0) break;
  }
  
  if (colorOptionPosition < 0) return;
  
  // Find størrelses-option position
  const sizeLinks = sizeContainer.querySelectorAll('.altli a');
  if (!sizeLinks.length) return;
  
  const firstSizeValue = sizeLinks[0].textContent.trim();
  
  for (let i = 0; i < variants.length; i++) {
    const variant = variants[i];
    for (let j = 0; j < variant.options.length; j++) {
      if (variant.options[j] === firstSizeValue && j !== colorOptionPosition) {
        sizeOptionPosition = j;
        break;
      }
    }
    if (sizeOptionPosition >= 0) break;
  }
  
  if (sizeOptionPosition < 0) return;
  
  // Opret en hurtig lookup-tabel for tilgængelige størrelser i den valgte farve
  const availableSizes = {};
  for (let i = 0; i < variants.length; i++) {
    const variant = variants[i];
    if (variant.options[colorOptionPosition] === selectedColor && variant.available) {
      availableSizes[variant.options[sizeOptionPosition]] = true;
    }
  }
  
  // Opdater hver størrelses-link baseret på den valgte farve
  sizeLinks.forEach(sizeLink => {
    const sizeValue = sizeLink.textContent.trim();
    const isAvailable = availableSizes[sizeValue] || false;
    
    // Opdater styling
    if (isAvailable) {
      sizeLink.classList.remove('is-disabled');
      sizeLink.title = sizeValue;
    } else {
      sizeLink.classList.add('is-disabled');
      sizeLink.title = 'Udsolgt';
    }
  });
} 